import { createFileRoute } from "@tanstack/react-router";

import { RoutePage, routeEntry } from "./routeTable";

const entry = routeEntry("/kcc/sales-forecasts");

export const Route = createFileRoute("/kcc/sales-forecasts")({
  head: () => ({
    meta: [
      { title: "KCC sales forecasts — LevelLoad" },
      { name: "description", content: "KCC sales forecasts — LevelLoad transport planning." },
      { property: "og:title", content: "KCC sales forecasts — LevelLoad" },
      {
        property: "og:description",
        content: "KCC sales forecasts — LevelLoad transport planning.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return <RoutePage entry={entry} />;
}
